import React from "react";
import { Settings } from "@mui/icons-material";
import { Container } from "@mui/material";
import { Helmet } from "~/components/Helmet";
import * as Layout from "~/layout";
import { SettingsSidebar } from "~/settings";
import { DsmNavigation } from "../../../DsmNavigation";
import { DataStoreCreateForm } from "./DataStoreCreateForm";

export function DataStoreCreatePage() {
  return (
    <>
      <Helmet>
        <title>New DataStore</title>
      </Helmet>
      <Layout.LayoutStateProvider>
        <Layout.Root>
          <Layout.Navigation>
            <DsmNavigation />
          </Layout.Navigation>
          <Layout.Header
            title="New DataStore"
            actions={
              <Layout.SidebarTrigger
                sidebarId="settings"
                title="Settings"
                icon={<Settings />}
              />
            }
          />
          <Layout.Main>
            <Layout.ScrollableContainer>
              <Container fixed>
                <DataStoreCreateForm />
              </Container>
            </Layout.ScrollableContainer>
          </Layout.Main>
          <Layout.Sidebar>
            <Layout.SidebarSwitch
              options={[
                { sidebarId: "settings", element: <SettingsSidebar /> },
              ]}
            />
          </Layout.Sidebar>
        </Layout.Root>
      </Layout.LayoutStateProvider>
    </>
  );
}
